import React from 'react';

const Pagination = ({ currentPage, totalItems, itemsPerPage, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const firstItem = (currentPage - 1) * itemsPerPage + 1;
    const lastItem = Math.min(currentPage * itemsPerPage, totalItems);

    if (totalPages <= 1) {
        return null; // N'affiche rien s'il n'y a qu'une seule page
    }

    return (
        <div className="flex items-center justify-between mt-4 px-4 py-2 bg-pro-dark-surface rounded-b-lg">
            <p className="text-sm text-pro-dark-text-secondary">
                Affiche {firstItem} à {lastItem} sur {totalItems} résultats
            </p>
            <div className="flex gap-2">
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-3 py-1 text-sm rounded-md bg-pro-dark-border hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Précédent
                </button>
                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-3 py-1 text-sm rounded-md bg-pro-dark-border hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Suivant
                </button>
            </div>
        </div>
    );
};

export default Pagination;